import { ArrowUp } from 'lucide-react';
import React, { useState, useEffect } from 'react';
import './style/ScrollToTop.css';

const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Show button when the user scrolls down 300px
    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    // Scroll the window to the top
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    return (
        <div className='fancy scroll-to-top-div' style={{
            ...styles.scrollToTopDiv, opacity: isVisible ? 1 : 0,
            visibility: isVisible ? 'visible' : 'hidden',
        }}>
            <button
                onClick={scrollToTop}
                style={{
                    ...styles.scrollToTopBtn,
                    opacity: isVisible ? 1 : 0,
                    visibility: isVisible ? 'visible' : 'hidden',
                }}
                className="scroll-to-top-btn">
                <ArrowUp size={30} />
                {/* Scroll to Top */}
            </button>
        </div>
    );
};

const styles = {
    scrollToTopDiv: {
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        padding: '10px 20px',
        fontSize: '16px',
        backgroundColor: '#1b1b1b',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        zIndex: 1000,
        width: 80,
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        transition: 'opacity 0.5s ease, visibility 0.5s ease', // Fade transition
    },
    scrollToTopBtn: {
        padding: '10px 20px',
        fontSize: '16px',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        backgroundColor: '#1b1b1b',
        zIndex: 1000,
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        transition: 'opacity 0.5s ease, visibility 0.5s ease', // Fade transition
    },
};

export default ScrollToTop;
